/**
 * Centralized cache configuration for the application
 * Provides standard TTL values, cache key patterns, and entity relationships
 */

/**
 * Standard TTL values for cache entries
 */
export const CACHE_TTL = {
  SHORT: 1 * 60 * 1000,    // 1 minute
  MEDIUM: 5 * 60 * 1000,   // 5 minutes
  LONG: 30 * 60 * 1000,    // 30 minutes
};

/**
 * Entity types for cache keys
 */
export enum CacheEntityType {
  POEM = 'poem',
  POET = 'poet',
  PROMPT_TEMPLATE = 'template',
  DEATHMATCH = 'deathmatch',
  SYSTEM_SETTING = 'setting',
}

/**
 * Cache key patterns
 */
export const CACHE_KEY_PATTERNS = {
  // Collection patterns
  ALL: (entity: CacheEntityType) => `${entity}s:all`,
  PAGINATED: (entity: CacheEntityType, page?: number, pageSize?: number) => 
    `${entity}s:paginated:${page || '*'}:${pageSize || '*'}`,
  
  // Single entity patterns
  BY_ID: (entity: CacheEntityType, id: string) => `${entity}:id:${id}`,
  
  // Relationship patterns
  BY_RELATION: (entity: CacheEntityType, relationEntity: CacheEntityType, relationId: string) => 
    `${entity}s:${relationEntity}:${relationId}`,
  
  // Special patterns
  BY_SUBJECT: (entity: CacheEntityType, subject: string) => 
    `${entity}s:subject:${subject}`,
};

/**
 * Basic entity relationships for cache invalidation
 * Maps entity types to their direct relationships
 */
export const BASIC_ENTITY_RELATIONSHIPS = {
  [CacheEntityType.POEM]: [
    { entity: CacheEntityType.POET, field: 'poet_id' },
  ],
  [CacheEntityType.POET]: [
    { entity: CacheEntityType.POEM, isParent: true },
  ],
  [CacheEntityType.PROMPT_TEMPLATE]: [],
  [CacheEntityType.DEATHMATCH]: [
    { entity: CacheEntityType.POEM, field: 'poem1_id' },
    { entity: CacheEntityType.POEM, field: 'poem2_id' },
  ],
  [CacheEntityType.SYSTEM_SETTING]: [],
}; 